export const callToActionOptions = [
	{ id: "BOOK_TRAVEL", name: "Book Now" },
	{ id: "CONTACT_US", name: "Contact Us" },
	{ id: "SEE_MENU", name: "See Menu" },

];

export default callToActionOptions;
